import { initMp } from './mp'
import { APP_VERSION } from 'common/constants'

export { MP_MANIFEST_LS } from './mp/constants'

export const setupMFEApps = () => {
  const cachedVersion = localStorage.getItem(APP_VERSION) || ''

  return initMp(cachedVersion)
}
